import pbRq from './pbRq';
import vipReq from './vipReq';

export default {
  ...pbRq,
  ...vipReq,
};
